import { Request } from "@xt/xtbase";

const { XtAxios4 } = Request;
const URL = "/sapi/v4/order/";

export function get_order(config?) {
  return XtAxios4.get(URL + "order", config);
}

export function post_order(config?) {
  return XtAxios4.post(URL + "order", null, config);
}

export function delete_order(config?) {
  return XtAxios4.delete(URL + "order", config);
}

export function get_openOrder(config?) {
  return XtAxios4.get(URL + "open-order", config);
}

export function delete_openOrder(config?) {
  return XtAxios4.delete(URL + "open-order", config);
}

export function get_historyOrder(config?) {
  return XtAxios4.get(URL + "history-order", config);
}

export function get_trade(config?) {
  return XtAxios4.get(URL + "trade", config);
}
